<script>
export default {
  name: "DidoApidocIntroduction",
};
</script>

<template>
  <div class="q-mt-md line-height-15">
    Bienvenue sur la documentation de l'API (application programming interface
    ou « interface de programmation d'application ») DiDo de diffusion en
    opendata des données produites par le SDES.
    <br /><br />
    Cette plateforme fournit un accès ouvert et gratuit à des données et des
    informations publiques produites par le SDES.
    <br />
    Elle permet ainsi de consulter ou récupérer une variété de données sur le
    logement, l'environnement, le transport, l'environnement et le changement
    climatique.
    <br /><br />
    La diffusion de ces données a été pensée dans un souci d'interopérabilité et
    de réutilisation.
    <br />
    L'ensemble des données diffusées peuvent être récupérées dans des formats
    ouverts et selon une licence permettant leur réutilisation.
  </div>
</template>
